<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerText]="T.PREVIEW_EXAM_DIALOG_TITLE | translate"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-file-search'}"
>
	<ng-container dialogContent>
		<div class="contentWrapper">
			@if (toggleControl.value === ParticipantDeviceAssessmentDisplayVariant.Examiner) {
				<sim-participant-device-examiner-assessment-display
					class="examinerAssessment"
					[assessment]="previewAssessment"
					[participant]="previewParticipant"
					[clinicalVignetteText]="T.PREVIEW_EXAM_DIALOG_CLINICAL_VIGNETTE_TEXT | translate"
				/>
			} @else if (toggleControl.value === ParticipantDeviceAssessmentDisplayVariant.Student) {
				<sim-participant-device-student-assessment-display class="studentAssessment" [assessment]="previewAssessment" />
			} @else if (toggleControl.value === ParticipantDeviceAssessmentDisplayVariant.SP) {
				<!--TODO: SIMSOFT-9725 - Implement real SP view-->
				<sim-participant-device-examiner-assessment-display
					class="spAssessment"
					[assessment]="previewAssessment"
					[participant]="previewParticipant"
					[clinicalVignetteText]="T.PREVIEW_EXAM_DIALOG_CLINICAL_VIGNETTE_TEXT | translate"
				/>
			}
		</div>
	</ng-container>

	<ng-container actions>
		<mat-button-toggle-group class="buttonToggleGroup" hideSingleSelectionIndicator [formControl]="toggleControl">
			<mat-button-toggle [value]="ParticipantDeviceAssessmentDisplayVariant.Examiner">
				<mat-icon fontIcon="fa-user-md" fontSet="fas" />
				{{ T.PREVIEW_EXAM_DIALOG_EXAMINER_VIEW | translate }}
			</mat-button-toggle>
			<mat-button-toggle [value]="ParticipantDeviceAssessmentDisplayVariant.Student">
				<mat-icon fontIcon="fa-user-graduate" fontSet="fas" />
				{{ T.PREVIEW_EXAM_DIALOG_STUDENT_VIEW | translate }}
			</mat-button-toggle>
			<mat-button-toggle [value]="ParticipantDeviceAssessmentDisplayVariant.SP">
				<mat-icon fontIcon="fa-user-injured" fontSet="fas" />
				{{ T.PREVIEW_EXAM_DIALOG_SP_VIEW | translate }}
			</mat-button-toggle>
		</mat-button-toggle-group>
	</ng-container>
</sim-basic-material-dialog>
